<div class="faq-page">
  <div class="row">
    <div class="mr-auto ml-auto">
      <div class="card-body">
        <app-faq></app-faq>
      </div>
    </div>
  </div>
</div>
